import { Auth } from "aws-amplify";
import { Box, Layer, TextInput, Text, Button } from "grommet";
import React, { useState } from "react";
import StandardColors from "../../../../../util/StandardColors";
import StandardFonts from "../../../../../util/StandardFonts";
import { useUser } from "../../../context/User/UserContext";
import { observer } from "mobx-react";
import { useStore } from "../../../../../Hooks/useStore";

type LoginPromptProps = {
  onCancel: () => void;
  onConfirmed: () => void;
};

function LoginPrompt({ onCancel, onConfirmed }: LoginPromptProps) {
  const [password, setPassword] = useState("");
  const [error, setError] = useState({
    errorVisible: false,
    errorMessage: "",
  });
  const { user } = useUser();
  const { rootStore } = useStore();



// Example usage



  const onConfirmClicked = () => {
    // setError({
    //   errorVisible: false,
    //   errorMessage: "",
    // });
    rootStore.loginPromptStore.setError(false,"");
    if (user) {
      rootStore.loadingStore.setShowLoader(true);
      Auth.signIn({ username: user?.username, password: rootStore.loginPromptStore.getPassword })
        .then((v) => {
          onConfirmed();
          rootStore.loadingStore.setShowLoader(false);
        })
        .catch((e) => {
          rootStore.loadingStore.setShowLoader(false);
          const message = e?.message?.includes("lambda")
            ? "Password must not be empty."
            : e?.message ?? "";
          // setError({
          //   errorVisible: true,
          //   errorMessage: message,
          // });
          rootStore.loginPromptStore.setError(true,message);
        });
    } else {  
      // setError({
      //   errorVisible: true,
      //   errorMessage: "User not logged in",
      // });
      rootStore.loginPromptStore.setError(true,"User not logged in");
    }
  };

  return (
    <Layer onClickOutside={onCancel}>
      <Box
        align="center"
        justify="center"
        gap="small"
        direction="column"
        alignSelf="center"
        pad="medium"
        flex
      >
        <Text style={StandardFonts.h42028Semibold}>Confirm your identity</Text>
        <TextInput
          title="username"
          value={user?.username}
          placeholder="username"
          color="blue"
          disabled={true}
        />
        <TextInput
          value={rootStore.loginPromptStore.getPassword}
          onChange={(e) => rootStore.loginPromptStore.setPassword(e.target.value)}
          type={"password"}
          title="password"
          placeholder="password"
        />
        <Box flex direction="row" justify="around" width={"100%"}>
          <Button color={StandardColors.secondary_red_100} onClick={onCancel}>
            Cancel
          </Button>
          <Button
            color={StandardColors.primary_blue_100}
            onClick={onConfirmClicked}
          >
            Confirm
          </Button>

         

        </Box>
        {rootStore.loginPromptStore.getIsErrorVisible && (
          <Text
            style={StandardFonts.h51624Medium}
            color={StandardColors.secondary_red_100}
          >
            {rootStore.loginPromptStore.getErrorMsg}
          </Text>
        )}
      </Box>
    </Layer>
  );
}

export default observer(LoginPrompt);
